import React, {useEffect, useState} from 'react';
import {Card, Rate, Tag} from "antd";
import dayjs from "dayjs";
import {BiPrinter} from "react-icons/bi";
import ZakazStore from "../../store/zakaz-store";
import BackServer from "../../api/BackServer";
import ReviewDetail from "../reviewDetail/reviewDetail";
import QueDetail from "../QueDetail/QueDetail";

const QueOne = (props) => {

    return (
        <>
            {Object.entries(props.dta.ques)
                .map( ([key, value]) =>
                    <>
                        <Card type="inner" title={
                            <>

                                    <Tag color="green-inverse">{dayjs(value.published_at).format("DD.MM.YYYY")}</Tag>
                                : {value.product.offer_id} <a href={value.product.url}
                                                              target={"_blank"}>{value.product.title}</a>
                            </>}
                              extra={
                                  <>
                                      <Rate disabled defaultValue={value.rating} allowHalf/>

                                  </>}>


                            {/*<Rate disabled defaultValue={value.rating} allowHalf/>*/}
                            {/*<p>{dayjs("2023-05-21T16:48:57.300810Z").format("DD.MM.YYYY")}</p>*/}



                            {/*<p style={{fontSize: '17px'}}>Кол видео: {value.videos_count} </p>*/}
                            {/*<p style={{fontSize: '17px'}}><Tag style={{fontSize: '17px'}}*/}
                            {/*                                   color="cyan">Покупатель:</Tag> {value.author_name} </p>*/}
                            {/*<p style={{fontSize: '17px'}}><Tag style={{fontSize: '17px'}}*/}
                            {/*                                   color="green">Плюсы:</Tag> {value.text.positive} </p>*/}
                            {/*<p style={{fontSize: '17px'}}><Tag style={{fontSize: '17px'}}*/}
                            {/*                                   color="red">Минусы:</Tag> {value.text.negative} </p>*/}
                            {/*<p style={{fontSize: '17px'}}><Tag style={{fontSize: '17px'}}*/}
                            {/*                                   color="cyan">Вопрос:</Tag> {value.text} </p>*/}


                            {/*<p>*/}

                            {/*    {(value.comments_amount.length < 1) ? (*/}
                            {/*        <>*/}
                            {/*            <span style={{fontSize: '17px'}}>Количество ответов: </span>*/}
                            {/*            <Tag color="red-inverse">Нет</Tag>*/}
                            {/*        </>*/}
                            {/*    ) : (*/}
                            {/*        <>*/}
                            {/*            <span style={{fontSize: '17px'}}>Количество ответов: </span>*/}
                            {/*            <Tag color="green-inverse">{value.comments_amount}</Tag>*/}
                            {/*        </>*/}
                            {/*    )}*/}
                            {/*</p>*/}
                            <QueDetail dta={value}/>
                            {/*<ReviewDetail dta={value}/>*/}
                        </Card>
                        {/*<Divider >{value.ship_date_str} - {value.posting_number} </Divider>*/}
                        {/*<h3>Заказ: {value.posting_number}</h3>*/}
                        {/*<Row  align="middle">*/}
                        {/*    <Col span={3}>*/}
                        {/*        <div className={"virov"}>*/}
                        {/*            {value.ship_date_str}*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    /!*<Col span={6}>*!/*/}
                        {/*    /!*    <div className={"virov"}>*!/*/}
                        {/*    /!*        {value.posting_number}*!/*/}
                        {/*    /!*    </div>*!/*/}
                        {/*    /!*</Col>*!/*/}
                        {/*    <Col span={3}>*/}
                        {/*        <div className={"virov"}>*/}
                        {/*            {value.status_rus}*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    /!*<Col span={6}>*!/*/}
                        {/*    /!*    <div className={"virov"}>*!/*/}
                        {/*    /!*        {value.substatus_rus}*!/*/}
                        {/*    /!*    </div>*!/*/}
                        {/*    /!*</Col>*!/*/}


                        {/*    {(value.Cancel_reason!="")?*/}

                        {/*        (*/}
                        {/*            <>*/}
                        {/*                /!*<a>AAA={value.Cancel_reason}</a>*!/*/}
                        {/*                <Col span={7}>*/}
                        {/*                    {value.prodlist.map((valuez) =>*/}
                        {/*                        <p>{valuez}</p>*/}
                        {/*                    )} </Col>*/}
                        {/*                <Col span={5}>*/}
                        {/*                    <Tag color={"red"}>{value.Cancel_reason}</Tag>*/}
                        {/*                </Col>*/}
                        {/*            </>*/}
                        {/*        ):(<>*/}
                        {/*            /!*<a>BBB={value.Cancel_reason}</a>*!/*/}
                        {/*            <Col span={15}>*/}
                        {/*                {value.prodlist.map((valuez) =>*/}
                        {/*                    <p>{valuez}</p>*/}
                        {/*                )} </Col>*/}
                        {/*        </>)}*/}

                        {/*</Row>*/}


                    </>

                )}
        </>
    );
};

export default QueOne;